"use strict";
exports.__esModule = true;
exports.createCustomerResponse = exports.updateCustomerResponse = void 0;
exports.updateCustomerResponse = { description: 'Account updated.' };
exports.createCustomerResponse = {
    customer_public_id: 'lTTdjPuizvZwR3dvXTNNlUw5dng1',
    biller_public_id: 'biller_public_id2',
    portal_response: {
        credential_status: undefined
    }
};
